import { getSession } from '../services/register.js';
import { getLastestVersion, releaseVersion } from '../services/pclab.js';
import { alertError, alertInfo, alertSuccess } from '../utils/edittools.js';
import { responseCode, responseData } from '../types/domain.js';
import type { VersionFormValue } from '../types/domain.js';
import type { ModelSaga, TypedModel } from './dva-types.js';

export interface UploadState {
  readonly versionData?: Readonly<Record<string, string>>;
  readonly dataValues?: Readonly<Record<string, VersionFormValue>>;
  readonly releaseLoading?: boolean;
}

const model: TypedModel<UploadState> = {
  namespace: 'upload',
  state: {},
  subscriptions: {
    setup({ dispatch, history }) {
      history.listen(({ pathname }) => {
        if (pathname !== '/pclab2/upload' && pathname !== '/pclab2/upload/') return;
        dispatch({ type: 'initialization' });
      });
    },
  },
  effects: {
    *initialization(_, { put }): ModelSaga {
      yield getSession();
      const response = yield getLastestVersion();
      if (responseCode(response) !== 0) {
        alertError(response instanceof Error ? response.message : '获取版本失败');
        return;
      }
      const data = responseData<Readonly<Record<string, string>>>(response) ?? {};
      const dataValues: Record<string, VersionFormValue> = {};
      for (const type of Object.keys(data)) dataValues[type] = { version: data[type], mode: type };
      yield put({ type: 'update', payload: { versionData: data, dataValues } });
    },
    *releaseVersion({ payload }, { put }): ModelSaga {
      const { version } = payload as { version: string };
      yield put({ type: 'update', payload: { releaseLoading: true } });
      const response = yield releaseVersion({ version });
      if (responseCode(response) !== 0) {
        alertError(response instanceof Error ? response.message : '发布失败');
        yield put({ type: 'update', payload: { releaseLoading: false } });
        return;
      }
      const data = responseData<{ message?: string }>(response);
      if (data?.message) alertInfo(data.message);
      yield put({ type: 'update', payload: { releaseLoading: false } });
      alertSuccess('发布成功');
    },
  },
  reducers: {
    update(state: UploadState, { payload }: { payload: Partial<UploadState> }): UploadState {
      return { ...state, ...payload };
    },
  },
};

export default model;
